// v3.0.0-rc.8e — Local Cart Store : petit panier client-side (localStorage)
// pour agréger les items "Ajouter au panier" avant commande finale.
// Clé isolée par phone user (empêche la fuite cross-account, cf fix session 2026-07-02).
//
// Événement custom `aya-cart-updated` dispatché à chaque mutation → écouté par
// LiveBanner pour rafraîchir count/dot sans latence.

import { trackSignal as _trackPwaSignal } from "@/pwa/valueSignals";

const EVENT = "aya-cart-updated";

function _key() {
  const phone = (typeof window !== "undefined" && (localStorage.getItem("civ_user_phone") || "")) || "anon";
  return `aya_local_cart_${phone.replace(/\W/g, "")}`;
}

function _emit() {
  try { window.dispatchEvent(new CustomEvent(EVENT)); } catch (_) { /* noop */ }
}

export function readCart() {
  try {
    const raw = localStorage.getItem(_key());
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch (_) { return []; }
}

export function saveCart(items) {
  try {
    localStorage.setItem(_key(), JSON.stringify(items || []));
    _emit();
  } catch (_) { /* quota, noop */ }
}

export function addItem(product) {
  const items = readCart();
  const idx = items.findIndex((x) => x.product_id === product.product_id);
  if (idx >= 0) {
    items[idx].qty = Math.min(99, (items[idx].qty || 1) + 1);
  } else {
    items.push({
      product_id: product.product_id,
      name: product.name,
      price_fcfa: Number(product.price_fcfa) || 0,
      merchant_id: product.merchant_id,
      merchant_name: product.merchant_name,
      photo: (Array.isArray(product.photos) && product.photos[0]) || null,
      emoji: product.emoji || null,
      qty: 1,
      added_at: Date.now(),
    });
  }
  saveCart(items);
  // v3.0.0-rc.8z-pwa — Signal PWA install (cart_add = signal fort).
  try { _trackPwaSignal('cart_add'); } catch (_) {}
  return items;
}

export function setQty(productId, qty) {
  const items = readCart();
  const idx = items.findIndex((x) => x.product_id === productId);
  if (idx < 0) return items;
  const q = Math.max(0, Math.min(99, Number(qty) || 0));
  if (q === 0) items.splice(idx, 1);
  else items[idx].qty = q;
  saveCart(items);
  return items;
}

export function removeItem(productId) { return setQty(productId, 0); }

export function clearCart() { saveCart([]); }

export function cartCount() {
  return readCart().reduce((s, x) => s + (x.qty || 0), 0);
}

export function cartTotal() {
  return readCart().reduce((s, x) => s + (x.qty || 0) * (x.price_fcfa || 0), 0);
}

export function subscribe(handler) {
  const wrap = () => handler(readCart());
  window.addEventListener(EVENT, wrap);
  window.addEventListener("storage", wrap);
  return () => {
    window.removeEventListener(EVENT, wrap);
    window.removeEventListener("storage", wrap);
  };
}

export const LOCAL_CART_EVENT = EVENT;
